import MonthlyReportModal from './MonthlyReportModal';

export default MonthlyReportModal;

